import { debugLog } from '../utils/utils'

/* global gtag */
const send = ({ props = {}, action, category, timeout = 3000 }) => {
  if (typeof gtag !== 'function') {
    /**
     * waiting for gtag to load
     */

    wait(timeout).then(() =>
      sendgtag({
        props,
        action,
        category,
      })
    )
    return
  }

  /**
   * when gta is set: immediate shipping
   */
  sendgtag({ category, action, props })
}

const sendgtag = ({ category, action, props }) => {
  typeof gtag !== 'function'
    ? console.warn('Google Analytics (gtag) not Loaded')
    : gtag('event', `${category}+${action}`, props)

  debugLog('gtag event', {
    event: `${category}+${action}`,
    event_parameters: props,
  })
}

const wait = (timeout) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(true)
      console.warn('Google Analytics (gtag) delayed')
    }, timeout)
  })
}

export default { send }
